import { AudioPlaybackState, IAudioPlayback } from '../../models/AudioPlayback';
import { ActionType } from '../action-types';
import { Action } from '../actions';

const initialState: IAudioPlayback = {
	projectActive: false,
	state: AudioPlaybackState.Paused,
	timelineTime: 0,
	audioFileId: null,
};

const reducer = (state: IAudioPlayback = initialState, action: Action): IAudioPlayback => {
	switch (action.type) {
		case ActionType.PLAY_AUDIO_FILE: {
			return {
				...state,
				state: AudioPlaybackState.PlayingAudioFile,
				audioFileId: action.payload.id,
			};
		}
		case ActionType.PLAY_TIMELINE: {
			return {
				...state,
				state: AudioPlaybackState.PlayingTimeline,
				timelineTime: action.payload.time,
				audioFileId: null,
			};
		}
		case ActionType.SET_TIMELINE_TIME: {
			return {
				...state,
				timelineTime: Math.max(action.payload.time, 0),
			};
		}
		case ActionType.UPDATE_TIMELINE_TIME: {
			return {
				...state,
				timelineTime: Math.max(action.payload.time, 0),
			};
		}
		case ActionType.STOP_PLAYBACK: {
			return {
				...state,
				state: AudioPlaybackState.Paused,
				audioFileId: null,
			};
		}
		case ActionType.RESET_STATE: {
			return initialState;
		}
		case ActionType.ACTIVATE_PROJECT: {
			return {
				...state,
				projectActive: true,
			};
		}
		case ActionType.INSERT_AUDIO_CLIP: {
			return {
				...state,
				timelineTime: action.payload.time + action.payload.duration,
			}
		}
		default:
			return state;
	}
};

export default reducer;
